export enum AdminRoles {
    ADMIN = 1,
    OWNER = 2,
    /**
     * @deprecated Quedó partido en SUPERVISOR_OPERATIVO y SUPERVISOR_MEDICO.
     * No se asigna a usuarios nuevos. Se comporta como el operativo hasta que
     * las cuentas que lo tienen se reasignen desde el admin.
     */
    SUPERVISOR = 3,
    DOCTOR = 4,
    COLLABORATOR = 5,
    SOPORTE = 6,
    /** Jefe de estación / responsable operativo (perfil del cliente). */
    SUPERVISOR_OPERATIVO = 7,
    /** Supervisión médica de la operación (perfil interno de UMA). */
    SUPERVISOR_MEDICO = 8,
    /**
     * Supervisor de línea (perfil del cliente): ve sólo "Indicadores por
     * línea", y sólo las líneas que tiene asignadas. El alcance lo valida la
     * API.
     */
    SUPERVISOR_LINEA = 9
}

export const adminRolesArray = Object.values(AdminRoles);
